module.exports = __webpack_public_path__ + "img/bot_yf4.32786bf3.png";